<template>
    <div style="width: 100%">
        <Breadcrumb></Breadcrumb>
        <div style="text-align: right;">
            <el-row style="background-color: #EEEEEE;margin-top: 10px">
                <el-col :span="24">
                    <el-button type="info" size="small" @click="goBack">返回</el-button>
                    <el-button type="warning" size="small" @click="saveEditForm">保存</el-button>
                </el-col>
            </el-row>
        </div>
        <!-- 基本信息 -->
        <el-form :model="editForm" ref="editForm" label-width="150px">
            <div class="t_plane self_el_item_form">
                <div class="pl_til">基本信息</div>
                <div class="pl_content">
                    <el-form-item prop="commSku" label="商品SKU：">
                        <span v-text="editForm.commSku"></span>
                    </el-form-item>
                    <el-form-item prop="chinName" label="中文名称：">
                        <span v-text="editForm.chinName"></span>
                    </el-form-item>
                </div>
            </div>
            <div class="t_plane self_el_item_form">
                <div class="pl_til">对应关系（平台SKU与商品SKU对应关系）</div>
                <div class="pl_content">
                    <el-form-item label="平台SKU：">
                        <el-tag
                                :key="item.id"
                                v-for="item in editForm.platSku"
                                closable
                                :disable-transitions="false"
                                @close="handleClose(item)"
                                effect="dark">
                            {{item.platSku}}
                        </el-tag>
                        <el-input
                                class="input-new-tag"
                                v-if="inputVisible"
                                v-model="inputValue"
                                ref="saveTagInput"
                                size="small"
                                @keyup.enter.native="handleInputConfirm"
                                @blur="handleInputConfirm"
                        >
                        </el-input>
                        <el-button v-else class="button-new-tag" size="small" @click="showInput">+ 新 增</el-button>
                    </el-form-item>
                </div>
            </div>
        </el-form>
    </div>
</template>

<script>
    import Breadcrumb from '@/components/common/Breadcrumb'
    import {getPlatSku,savePlatSku} from "@/api/store/storeManage"
    export default {
        name:'pairEdit',
        components:{Breadcrumb},
        data: function () {
            return {
               editForm:{
                   wareId:null,
                   commSku:null,
                   chinName:null,
                   platSku:[]
               },
                inputVisible: false,
                inputValue: ''
            };
        },
        created(){
            //回显数据
            let data = JSON.parse(this.$route.query.data);
            this.editForm.commId = data.commId;
            this.editForm.commSku = data.commSku;
            this.editForm.chinName = data.chinName;
            if(this.editForm.commId){
                getPlatSku(this.editForm.commId).then(res =>{
                    if(res.code == 200){
                        this.editForm.platSku = res.data;
                    }
                }).catch(err =>{});
            }

        },
        methods: {
            saveEditForm(){
                let skuNameArr = [];
                this.editForm.platSku.forEach(sku =>{
                    skuNameArr.push(sku.platSku);
                })
                let data = {commId:this.editForm.commId,platSkuArr:this.editForm.platSku,platSkuStr:skuNameArr.join(',')}
                savePlatSku(data).then(res =>{
                    if(res.code == 200){
                        this.$message.success("保存成功")
                    }
                }).catch();
            },
            goBack(){
                this.$router.go(-1);
            },

            handleClose(tag) {
                this.editForm.platSku.splice(this.editForm.platSku.indexOf(tag), 1);
            },

            showInput() {
                this.inputVisible = true;
                this.$nextTick(_ => {
                    this.$refs.saveTagInput.$refs.input.focus();
                });
            },

            handleInputConfirm() {
                let inputValue = this.inputValue;
                if (inputValue) {
                    this.editForm.platSku.push(
                        {   id:null,
                            commId:this.editForm.commId,
                            commSku:this.editForm.commSku,
                            platSku:inputValue,
                            updateEmpNo:this.$store.state.user.name,
                        });
                }
                this.inputVisible = false;
                this.inputValue = '';
            }
        }
    }
</script>

<style>
    /*去除按钮的左边框*/
    .searchType .el-radio-button:first-child .el-radio-button__inner {
        border-left: 0px solid #DCDFE6;
    }

    /*去除按钮的边框*/
    .searchType .el-radio-button__inner {
        border: 0px solid #DCDFE6;
    }
    .self_el_item_form .el-form-item__content ,.self_el_item_form .el-form-item__label{
        line-height: 30px !important;
    }
    .self_el_item_form .el-form-item{
        margin-bottom:17px !important;
    }
    .el-tag {

    }
    .el-tag{
        margin-right: 10px;
        margin-top: 5px;
    }
    .button-new-tag {
        height: 32px;
        line-height: 30px;
        padding-top: 0;
        padding-bottom: 0;
    }
    .input-new-tag {
        width: 90px;
        vertical-align: bottom;
    }
</style>
